<template>
	<div class="loader" :class="{ 'loader--infinite': infinite }">
		<svg viewBox="0 0 216 216" xmlns="http://www.w3.org/2000/svg">
			<circle cx="108" cy="108" r="98" :style="{ strokeDashoffset: 615 - progress * 615 + 'px'}"></circle>
			<text x="108" y="125.412">
				{{ Math.round(progress * 100) }}%
			</text>
		</svg>
	</div>
</template>

<script>
export default {
	props: {
		progress: {
			type: Number,
			default: 0
		},
		infinite: {
			type: Boolean,
			default: true
		}
	}
}
</script>

<style lang="scss" scoped>
.loader {
	svg {
		width: 100%;
		height: auto;
	}

	circle {
		fill: none;
		stroke: $clrRed;
		stroke-width: 6px;
		stroke-linecap: round;
		stroke-dasharray: 615px;
		transform-origin: center;
		will-change: auto;
	}
	&--infinite circle {
		animation: spin 2s linear infinite, rotate 2.5s linear infinite;
	}

	text {
		fill: $clrRed;
		font-size: 58px;
		font-weight: 500;
		text-anchor: middle;
	}
}

@keyframes spin {
	0% {
		stroke-dasharray: 615px;
		stroke-dashoffset: 615px;
	}
	50% {
		stroke-dasharray: 308px;
	}
	100% {
		stroke-dasharray: 615px;
		stroke-dashoffset: -615px;
	}
}
@keyframes rotate {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
